import merge from 'lodash/merge';

const state = {
  allIds: [],
  byId: {}
};
const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addPackages: ({ commit }, packages) =>
    packages.forEach(pkg => commit('add', pkg))
};

const mutations = {
  add: (state, pkg) => {
    const merged = merge({}, state.byId[pkg.id], pkg);
    state.byId[pkg.id] = merged;

    if (!state.allIds.includes(pkg.id)) {
      state.allIds.push(pkg.id);
    }
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
